import { render, staticRenderFns } from "./NewsDetailTow.vue?vue&type=template&id=84842c7e&scoped=true&"
import script from "./NewsDetailTow.vue?vue&type=script&lang=js&"
export * from "./NewsDetailTow.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailTow.vue?vue&type=style&index=0&id=84842c7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84842c7e",
  null
  
)

export default component.exports